'use client';

import { TranslationSnapshotProvider } from '@eliadmin/core/src/i18n/translation-context';
import type { PropsWithChildren } from 'react';
import { GENERATED_TRANSLATIONS } from '../dictionaries/dictionary-133df795d4804cd493018c615724c5486863056285040576e9b429c64a31fd29';

export default function GeneratedLocaleTranslationBoundary({ children }: PropsWithChildren) {
  return (
    <TranslationSnapshotProvider translations={GENERATED_TRANSLATIONS}>
      {children}
    </TranslationSnapshotProvider>
  );
}
